/* eslint-disable react/prop-types */
import PropTypes from 'prop-types'
import * as Constants from '../../../misc/Constants'
import Input from '../../common/form/Input'
import ConfirmationModal2 from '../../common/ConfirmationModal2'
import SubmitButton from '../../common/buttons/SubmitButton'
import CancelButton from '../../common/buttons/CancelButton'
import FieldError from '../../common/FieldError'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import './PackageForm.scss'

const PackageForm = ({
  action,
  formPackage,
  setFormPackage,
  errors,
  loading,
  handleAddPackage,
  handleUpdatePackage,
  handleCloseModal,
  closeModal,
  showPackageConfirmationModal,
  setShowPackageConfirmationModal,
}) => {
  const currency = useSelector(state => state.user.current_user.communities[0].currency)
  const { t } = useTranslation()

  const handleInputChange = e => {
    const inputName = e.target.name
    const inputValue = e.target.value
    if (inputName === 'name' && inputValue.length <= 100) {
      setFormPackage({ ...formPackage, name: inputValue })
    } else if (inputName === 'price' && (inputValue.match(Constants.PRICE_REGEX) || inputValue === '')) {
      setFormPackage({ ...formPackage, price: inputValue })
    } else if (inputName === 'description' && inputValue.length <= 1000) {
      setFormPackage({ ...formPackage, description: inputValue })
    }
  }

  const formValid = () => {
    if (formPackage.name === '' || formPackage.price === '') {
      return false
    }
    return true
  }

  return (
    <div id='PackageForm'>
      <div className='container-fluid p-0'>
        <div className='row'>
          <div className='col-12 mb-2'>
            <h1 className='form-title'>
              {action === Constants.FORM_ACTIONS.EDIT
                ? t('communitySettings.pricing.packageForm.editTitle')
                : t('communitySettings.pricing.packageForm.createTitle')}
            </h1>
          </div>
          <div className='col-12 mb-2'>
            {errors?.general && <FieldError message={errors.general} style={{ paddingBottom: '5px' }} general />}
            <div className='d-flex justify-content-between align-items-start'>
              <label htmlFor='nameInput' className='form-label'>
                {t('common.field.name')} <span className='required-text'>*</span>
              </label>
              <p className='character-counter m-0'>
                {t('communitySettings.pricing.packageForm.charactersCount', { count: formPackage.name.length, max: 100 })}
              </p>
            </div>
            <Input
              id='nameInput'
              name='name'
              type='text'
              onChange={handleInputChange}
              placeholder={t('communitySettings.pricing.packageForm.namePlaceholder')}
              value={formPackage.name}
              error={errors?.name}
            />
          </div>
          <div className='col-6 mb-2'>
            <label htmlFor='priceInput' className='form-label'>
              {t('communitySettings.pricing.packageForm.price')} <span className='required-text'>*</span>
            </label>
            <Input
              id='priceInput'
              name='price'
              type='number'
              symbol={currency.symbol}
              onChange={handleInputChange}
              onWheel={(e) => e.target.blur()}
              placeholder={t('communitySettings.pricing.packageForm.pricePlaceholder')}
              value={formPackage.price}
              error={errors?.price}
            />
          </div>
          <div className='col-12 mb-2'>
            <div className='d-flex justify-content-between align-items-start'>
              <label htmlFor='descriptionInput' className='form-label'>
                {t('common.field.description')}
              </label>
              <p className='character-counter m-0'>
                {t('communitySettings.pricing.packageForm.charactersCount', { count: formPackage.description.length, max: 1000 })}
              </p>
            </div>
            <Input
              id='descriptionInput'
              name='description'
              type='textarea'
              onChange={handleInputChange}
              placeholder={t('communitySettings.pricing.packageForm.descriptionPlaceholder')}
              value={formPackage.description}
              error={errors?.description}
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-6'>
            <CancelButton
              onClick={handleCloseModal}
              buttonMessage={t('common.cancel')}
              className='mt-3'
            />
          </div>
          <div className='col-6'>
            <SubmitButton
              onClick={action === Constants.FORM_ACTIONS.EDIT ? handleUpdatePackage : handleAddPackage}
              disabled={!formValid()}
              buttonMessage={action === Constants.FORM_ACTIONS.EDIT
                ? (loading
                  ? t('communitySettings.pricing.packageForm.savingChangesButton')
                  : t('communitySettings.pricing.packageForm.saveChangesButton'))
                : (loading
                  ? t('communitySettings.pricing.packageForm.creatingPackageButton')
                  : t('communitySettings.pricing.packageForm.createPackageButton'))}
            />
          </div>
        </div>
      </div>
      <ConfirmationModal2
        showModal={showPackageConfirmationModal}
        closeModal={() => setShowPackageConfirmationModal(false)}
        onDeny={() => setShowPackageConfirmationModal(false)}
        denyMessage={t('common.no')}
        onProceed={closeModal}
        proceedMessage={t('common.yes')}
        icon={<i className='fa fa-question-circle' style={{ fontSize: '72px' }} />}
        title={t('communitySettings.pricing.packageForm.discardChangesTitle')}
        message={t('communitySettings.pricing.packageForm.discardChangesMessage')}
      />
    </div>
  )
}

PackageForm.propTypes = {
  action: PropTypes.oneOf([
    Constants.FORM_ACTIONS.ADD,
    Constants.FORM_ACTIONS.EDIT,
  ]),
}


export default PackageForm
